// Nagłówek przyklejony u góry: po przewinięciu dostaje kreskę i cień (is-stuck),
// przy przewijaniu w dół chowa się, w górę – wraca (is-hidden; bez chowania przy „ogranicz ruch”).
export function initStickyHeader() {
    const header = document.querySelector("[data-cc-header]");
    if (!header) {
        return;
    }
    const hide = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lastY = window.scrollY;
    let ticking = false;

    const update = () => {
        ticking = false;
        const y = window.scrollY;
        header.classList.toggle("is-stuck", y > 8);
        if (hide) {
            if (y > lastY + 4 && y > header.offsetHeight * 2 && !header.classList.contains("is-open") && !header.contains(document.activeElement)) {
                header.classList.add("is-hidden");
            } else if (y < lastY - 4 || y < header.offsetHeight) {
                header.classList.remove("is-hidden");
            }
        }
        if (Math.abs(y - lastY) > 4) {
            lastY = y;
        }
    };

    window.addEventListener("scroll", () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }, {passive: true});
    header.addEventListener("focusin", () => header.classList.remove("is-hidden"));
    update();
}
